import DashboardDeleteConfirmation from './DashboardDeleteConfirmation';

export default DashboardDeleteConfirmation;
